import {
    CellFormatterService,
    TableOptions
} from '../common/datatable';
import { AuditModifiedFieldComponent } from './audit-modified-fields/audit-modified-field.component';
import { AuditClassFactory } from './audit-class-maker';
import { TranslationService } from '@services/translation.service';

export class AuditOrdersInstitutionsTableOptions {

    options: TableOptions;

    constructor(
        private cellFormatterService: CellFormatterService,
        private translationService: TranslationService
    ) {
        this.options = this.getDefaultOptions();
    }

    getDefaultOptions(): TableOptions {
        return {
            csvFileName: `orders-${this.translationService.translate('Institution').toLowerCase()}s-audit.csv`,
            enableDetailColumn: false,
            enableDraggable: false,
            enableSelectable: false,
            enableAuditColumns: false,
            columns: [
                {
                    displayName: 'Type',
                    field: 'UpdateType',
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified Fields',
                    field: 'ModifiedFields',
                    sortField: 'ModifiedFields',
                    rendererComponent: AuditModifiedFieldComponent,
                    exportFormatter: this.cellFormatterService.auditModifiedFieldsExportFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Date',
                    field: 'ModifiedDate',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified By',
                    field: 'ModifiedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Order ID',
                    field: 'OrderID',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('OrderID', 'OrderID'),
                    cellClass: AuditClassFactory.createCellClass('orderid'),
                },
                {
                    displayName: this.translationService.translate('Institution'),
                    field: 'Institution',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Institution', (this.translationService.translate('Institution'))),
                    cellClass: AuditClassFactory.createCellClass(this.translationService.translate('Institution').toLowerCase()),
                },
                {
                    displayName: 'Site',
                    field: 'Site',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('Site', 'Site'),
                    cellClass: AuditClassFactory.createCellClass('site'),
                },
                {
                    displayName: 'Created By',
                    field: 'CreatedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Created Date',
                    field: 'DateCreated',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                }
            ]
        };
    }
}
